import axios from "axios";
import { EventFilterRequest, EventResponse, EventResponseDto } from "./Dtos/EventsDtos";

// Following the existing service pattern in the codebase
export const EventsService = {
  events: {
    /**
     * Filter events based on provided criteria
     * @param filters - Event filter parameters
     * @returns Promise with event response data
     */
    filter: async (filters: EventFilterRequest): Promise<EventResponse> => {
      const response = await axios.post<EventResponseDto[]>(
        "/api/v1/events/filter",
        filters,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // API returns an array directly, so wrap it in the expected format
      return {
        success: true,
        data: response.data,
      };
    },

  },
};
